import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Users,
  Search,
  Filter,
  Plus,
  Mail,
  Phone,
  MapPin,
  MoreHorizontal,
  User,
  Car
} from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import DashboardLayout from '../components/Layout/DashboardLayout';

const KundenPage = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    
    if (!token || !userData) {
      navigate('/');
      return;
    }
    
    setUser(JSON.parse(userData));
  }, [navigate]);

  // Mock customers data
  const customers = [
    { 
      id: 1, 
      name: 'Max Mustermann', 
      email: 'max@mustermann.de', 
      phone: '0221-12345678',
      adresse: 'Musterstraße 123, 50667 Köln',
      faelle: 3,
      letzterKontakt: '15.01.2024'
    },
    { 
      id: 2, 
      name: 'Erika Schmidt', 
      email: 'erika@schmidt.de', 
      phone: '0221-87654321',
      adresse: 'Hauptstraße 45, 50668 Köln',
      faelle: 1,
      letzterKontakt: '12.01.2024'
    },
    { 
      id: 3, 
      name: 'Thomas Weber', 
      email: 'thomas.weber@email.de', 
      phone: '0221-11223344',
      adresse: 'Nebenstraße 7, 50669 Köln',
      faelle: 5,
      letzterKontakt: '10.01.2024'
    },
  ];

  if (!user) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <DashboardLayout user={user}>
      <div className="p-4 lg:p-6">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Kunden</h1>
            <p className="text-gray-500 text-sm">Kundenverwaltung und Kontakte</p>
          </div>
          <Button className="bg-gradient-to-r from-[#29beff] to-[#5dd3ff] text-white gap-2">
            <Plus className="w-4 h-4" />
            Neuer Kunde
          </Button>
        </div>
        
        {/* Search */}
        <div className="bg-white rounded-xl border border-gray-200 mb-6">
          <div className="p-4 flex flex-wrap items-center gap-3">
            <div className="relative flex-1 min-w-[200px]">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <Input placeholder="Kunden suchen..." className="pl-10" />
            </div>
            <Button variant="outline" className="gap-2">
              <Filter className="w-4 h-4" />
              Filter
            </Button>
          </div>
        </div>
        
        {/* Customer Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {customers.map((customer) => (
            <div key={customer.id} className="bg-white rounded-xl border border-gray-200 p-5 hover:shadow-md transition-shadow">
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#29beff] to-[#5dd3ff] rounded-full flex items-center justify-center text-white font-semibold">
                    {customer.name.split(' ').map(n => n[0]).join('')}
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">{customer.name}</h3>
                    <p className="text-sm text-gray-500">{customer.faelle} Fälle</p>
                  </div>
                </div>
                <button className="p-1 hover:bg-gray-100 rounded">
                  <MoreHorizontal className="w-5 h-5 text-gray-400" />
                </button>
              </div>
              
              <div className="space-y-2 text-sm">
                <div className="flex items-center gap-2 text-gray-600">
                  <Mail className="w-4 h-4 text-gray-400" />
                  {customer.email}
                </div>
                <div className="flex items-center gap-2 text-gray-600">
                  <Phone className="w-4 h-4 text-gray-400" />
                  {customer.phone}
                </div>
                <div className="flex items-center gap-2 text-gray-600">
                  <MapPin className="w-4 h-4 text-gray-400" />
                  {customer.adresse}
                </div>
              </div>
              
              <div className="mt-4 pt-4 border-t border-gray-100 flex items-center justify-between">
                <span className="text-xs text-gray-500">Letzter Kontakt: {customer.letzterKontakt}</span>
                <Button variant="outline" size="sm" className="gap-1 text-xs">
                  <Car className="w-3 h-3" />
                  Fälle
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default KundenPage;
